import { useHookstate } from "@hookstate/core";
import PropTypes from "prop-types";
import React from "react";
import { Dropdown } from "primereact/dropdown";
import { currentInstallation, scrbData, sortOptions, translateList } from "../ScrbTools";
import { FloatLabel } from "primereact/floatlabel";
import { classNames } from "primereact/utils";
import { I18n } from "aws-amplify";

ReceptionGenre.propTypes = {
    editable: PropTypes.bool.isRequired
}

export default function ReceptionGenre(props) {
    const installation = useHookstate(currentInstallation);
    const data = useHookstate(scrbData).get();

    return (
        <div className="flex flex-column pt-5">
            <div className="flex flex-column">
                <h2 className="text-xl font-semibold mb-4">
                    <i className="fa-light fa-building-magnifying-glass" style={{ marginRight: '0.5rem' }}></i>
                    {I18n.get("reception")}
                </h2>
                <div className="pt-2">
                    <FloatLabel>
                        <Dropdown
                            id="genreReception"
                            value={installation.get().genreReception}
                            onChange={(e) => installation["genreReception"].set(e.value)}
                            options={sortOptions(translateList(data.genreReceptionsList))}
                            optionValue="id"
                            optionLabel="label"
                            placeholder={I18n.get("genreReception")}
                            className={classNames({
                                "w-full": true,
                                "p-invalid": !installation.get().genreReception
                            })}
                            autoComplete="off"
                            disabled={!props.editable}
                        />
                        <label htmlFor="genreReception">{I18n.get("genreReception")}</label>
                    </FloatLabel>
                </div>
            </div>
        </div>
    );
}
